<template>
  <b-row class="w-100 m-auto px-0">

    <b-input-group>
      <b-form-textarea
        class="spnod-text--thin mr-2"
        placeholder="Type here..."
        rows="1"
        v-model="model.messageBody"
        v-on:keyup.enter="$emit('sendMessage')"
        v-on:click.stop.prevent="$emit('scrollPage')"
        :disabled="!canSend">
      </b-form-textarea>
      <b-input-group-append>
        <b-button
          type="submit"
          class="spnod-admin__form--button px-3"
          value="SEND"
          v-on:click.stop.prevent="$emit('sendMessage')"
          :disabled="!canSend">
          Send
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TextArea',
  props: ['consented', 'model'],
  computed: {
    ...mapGetters(['canSend'])
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Messaging/TextArea.vue?4ec248a0